import React, {Component, createRef, Fragment} from 'react';

import '../../chat.css';
import Localization from '../../config/localization/Localization'
import ChatInputField from './chatInputField/ChatInputField';
import ChatAttachment from "./chatAttachment/ChatAttachment";
import ChatInputMenu from "./chatInputMenu/ChatInputMenu";
import IntegrationTypeEnum from "../../config/constants/IntegrationTypeEnum";
import {getLocalizationLanguageCode} from "../../util/localization";
import Autocomplete from "./autocomplete/Autocomplete";
import { debounce, removeHtmlTagsFromString} from "../../util/utilMethods";
import LayoutTypeEnum from "../../config/constants/LayoutTypeEnum";
import Description from '@material-ui/icons/Description';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import Image from '@material-ui/icons/Image';
import TextFields from '@material-ui/icons/TextFields';
import ChatQuestionTypeEnum from '../../config/constants/ChatQuestionTypeEnum';




/**
 * Class for the chat message input menu.
 */
class ChatInput extends Component {

    constructor(props) {
        super(props);
        this.inputRef = null;
        this.autoCompleteRef = createRef();
        this.handleGetTrainingPhraseListDebounced = debounce((searchText) => this.handleGetTrainingPhraseList(searchText), 200)
        this.state = {
            message: '',
            isMenuTriggered: false,
            lastSentMessage: '',
            showDuplicateMessageError: false,
            intent: null
        }
    }

    componentDidUpdate(prevProps) {
        // Sync state with prop when it changes
        if ((prevProps.message !== "" && prevProps.message !== this.props.message) || (this.props.isMenuTriggered && !prevProps.isMenuTriggered)) {
            this.setState({ message: this.props.message });

            if(this.props.intent.intentId) {
                this.props.sendIntent(this.props.intent.intentId, ChatQuestionTypeEnum.menuItem,
                    this.props.message, null, null, this.props.intent.id);
            }
            else {
                this.props.sendMessage(this.props.message, this.props.message);
            }
            
            let message = this.props.message;

            if ( this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.props.chatConfig.withMemory) {
                message = '';
            }

            this.setState({message: message}, () => {
                this.props.setIsMenuTriggered(false);
            });
        }
    }

    handleGetTrainingPhraseList = (searchText) => {
        this.props.handleGetTrainingPhraseList(searchText)
    }

    handleMessageChanges = (message, disableAutomComplete = false) => {
        this.props.handleRootClick();

        if (this.state.showDuplicateMessageError) {
            this.setState({ showDuplicateMessageError: false });
        }

        this.setState({message: message}, () => {
            if(this.props.chatAgentMode){
                if(message.charAt(0) === "#" && message.length >= 3) {
                    const formattedSearchString = message.substring(1).trim().toLowerCase();
                    this.handleGetTrainingPhraseListDebounced(formattedSearchString)
                }
            } else if(this.props.chatConfig.enableAutocomplete){
                if(message.length >= 1 && disableAutomComplete === false) {
                    const formattedSearchString = message.trim().toLowerCase();
                    this.handleGetTrainingPhraseListDebounced(formattedSearchString)
                }
            }
        });
    };

    handleChangeFocusToInput = () => {
        //Textarea is burried in two divs, and therefore firstchild is used twice
        if(this.inputRef.firstChild && this.inputRef.firstChild.firstChild){
            this.inputRef.firstChild.firstChild.focus()
        }
    }

        handleResetChatInput = () => {
        this.setState({message: '', lastSentMessage: '', showDuplicateMessageError: false})
        this.props.reEnableMostAskedQuestions();
        this.props.clearSpeechBubble();

    }

    handleEditChatAgentIntent = (intentId) => {
        this.props.handleGetChatResponse(intentId)
            .then((result) => {
                if(result != null && result.speechBubbleList != null){
                   let chatResponseString = '';
                   result.speechBubbleList.forEach((speechBubble, sbIndex) => {
                        if(speechBubble.messageList != null){
                            speechBubble.messageList.forEach((message, mIndex) => {
                                //Adds space between messages except first and last message
                                if(!(sbIndex === 0 && mIndex === 0)
                                    && !(sbIndex ===  result.speechBubbleList.length-1 && mIndex === speechBubble.messageList)) {
                                    chatResponseString += " ";
                                }
                                if(message.content != null) {
                                    const strippedString = removeHtmlTagsFromString(message.content)
                                    chatResponseString += strippedString
                                } else if(message.url != null){
                                    chatResponseString += message.url
                                }
                            })
                        }
                    })
                    this.setState({message: chatResponseString})
                    this.props.flushTrainingPhraseList();
                    this.handleChangeFocusToInput()
                }
            }).catch((e) => {
                console.log(e)
            })
    }

    handleSendChatAgentIntent = (intentId) => {
        const messageWasSent = this.props.sendChatAgentIntent(intentId);
        if(messageWasSent){
            this.setState({message: ''})
            this.props.flushTrainingPhraseList();
            this.handleChangeFocusToInput()
        }
    }

    handleSendMessage = (disableAutocomplete = false) => {

        if(this.props.chatConfig.layoutMode !== null && this.props.chatConfig.layoutMode === LayoutTypeEnum.chatBot) {
            this.props.updateStateOfPlaceholder();
        }

        if (this.state.message.replace(/(<([^>]+)>)/ig, "").trim() !== '') {
            const currentMessage = this.state.message.replace(/(<([^>]+)>)/ig, "").trim();
            
            if (this.state.lastSentMessage && currentMessage === this.state.lastSentMessage) {
                this.setState({ showDuplicateMessageError: true });

                setTimeout(() => {
                    this.setState({ showDuplicateMessageError: false });
                }, 3000);

                return;
            }
            
            this.props.sendUserIsWriting(false);
            
            const messageWithLineBreaks = this.state.message.replace(/\n/g, '<br>');
            let messageWasSent = this.props.sendMessage(messageWithLineBreaks, messageWithLineBreaks);

            if(disableAutocomplete == true)
            {
                this.props.flushTrainingPhraseList();
                this.handleChangeFocusToInput()
            }

            if ( messageWasSent &&
                (
                    this.props.chatConfig.layoutMode === LayoutTypeEnum.chatBot ||
                    (this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.props.chatConfig.withMemory)
                )
            ) {
                this.setState({ lastSentMessage: currentMessage });
                this.handleMessageChanges('', disableAutocomplete);
            } else if (messageWasSent) {
                this.setState({ lastSentMessage: currentMessage });
            }
        }
    };

    handleSendUserSuggestion = (message) => {
        let messageWasSent = this.props.sendMessage(message, message);
        if (messageWasSent) {
            if ( this.props.chatConfig.layoutMode === LayoutTypeEnum.chatBot ||
                (this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.props.chatConfig.withMemory))
            {
                message= '';
            }

            this.handleMessageChanges(message, true);
            this.props.flushTrainingPhraseList();
            this.handleChangeFocusToInput()
        }
    }

    handleInputUpKeyStroke = () => {
        if(this.props.chatConfig.layoutMode === LayoutTypeEnum.chatBot && this.autoCompleteRef && this.autoCompleteRef.lastChild){
            this.autoCompleteRef.lastChild.focus()
        }
    }

    handleInputDownKeyStroke = () => {
        if(this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.autoCompleteRef && this.autoCompleteRef.firstChild){
            this.autoCompleteRef.firstChild.focus()
        }
    }

    render() {
        const localizationCode = getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null)
        const fileTypeIconMap = {
            PDF: <PictureAsPdf style={{ color: '#e74c3c', fontSize: '18px' }} />,
            DOCX: <Description style={{ color: '#3498db', fontSize: '18px' }} />,
            JPG: <Image style={{ color: '#2ecc71', fontSize: '18px' }} />,
            PNG: <Image style={{ color: '#f1c40f', fontSize: '18px' }} />,
            TXT: <TextFields style={{ color: '#9b59b6', fontSize: '18px' }} />,
            default: <Description style={{ color: '#95a5a6', fontSize: '18px' }} />,
        };
        return(
            <div id={'chat-input-container'} onClick={this.onClick}>
                {
                    this.props.disclaimer && this.props.chatConfig.layoutMode !== LayoutTypeEnum.searchBot &&  <div id={'chat-disclaimer'} dangerouslySetInnerHTML={{__html: this.props.disclaimer}}/>
                }
                {/* File Upload List */}
                {this.props.fileUploadedList && this.props.fileUploadedList.length > 0 && (
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '10px',
                            backgroundColor: '#f9f9f9',
                            borderBottom: '1px solid #ddd',
                            padding: '5px'
                        }}
                    >
                        {!this.props.botWriting && this.props.fileUploadedList.map((file, index) => {
                            const fileExtension = file.split('.').pop().toUpperCase();
                            const fileIcon = fileTypeIconMap[fileExtension] || fileTypeIconMap.default;

                            return (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center', // Ensures vertical alignment
                                        padding: '8px 12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        maxWidth: '200px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    <div
                                        style={{
                                            padding: '0px',
                                            marginRight: '8px', // Adds space between icon and text
                                            display: 'flex',
                                            alignItems: 'center', // Ensures icon is vertically centered
                                        }}
                                    >
                                        {fileIcon}
                                    </div>

                                    {/* File Name */}
                                    <div
                                        style={{
                                            flex: '1',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '12px',
                                            display: 'flex',
                                            alignItems: 'center', // Ensures text is vertically centered
                                        }}
                                        title={file}
                                    >
                                        {file}
                                    </div>



                                    <div
                                        onClick={() => this.props.handleDeleteUploadedFile(file)}
                                        style={{
                                            marginLeft: '10px',
                                            color: '#000000',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            display: 'flex',
                                            alignItems: 'center', // Ensures delete icon is vertically centered
                                        }}
                                    >
                                        ✖
                                    </div>

                                </div>
                            );
                        })}
                    </div>
                )}


                {(this.props.chatAgentMode || this.props.chatConfig.enableAutocomplete) && this.inputRef && this.props.language &&
                    <Autocomplete
                        chatAgentMode={this.props.chatAgentMode}
                        ref={(el) => this.autoCompleteRef = el}
                        anchorEl={this.inputRef}
                        searchString={this.state.message}
                        trainingPhraseList={this.props.trainingPhraseList}
                        flushTrainingPhraseList={this.props.flushTrainingPhraseList}
                        onEditChatAgentIntent={this.handleEditChatAgentIntent}
                        onSendChatAgentIntent={this.handleSendChatAgentIntent}
                        onSendUserSuggestion={this.handleSendUserSuggestion}
                        language={this.props.language}
                        onChangeFocusToInput={() => this.handleChangeFocusToInput()}
                        showAbove= {this.props.chatConfig.layoutMode === LayoutTypeEnum.chatbot ||
                            (this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.props.chatConfig.openDownwards === false)}
                    />
                }
                <div id={'chat-show-error-container'} style={this.props.showConnectionLostMsg === false ? {display: 'none'} : null}>
                    {Localization[localizationCode]['chatInput.connectionProblems']}<br/>
                    {Localization[localizationCode]['chatInput.reconnecting']}
                </div>
                <div id={'chat-show-duplicate-error-container'} style={{
                    ...(!this.state.showDuplicateMessageError || this.props.showConnectionLostMsg) ? {display: 'none'} : {},
                    ...((this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot) ? (this.props.chatConfig.openDownwards ? {top: '85px'} : {top: '40px'}) : {top: '65px'})
                }}>
                    {Localization[localizationCode]['chatInput.duplicateMessage']}
                </div>
                <div 
                id={this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot ? 'search-bot-show-input-container' : 'chat-show-input-container'} 
                ref={(div) => this.inputRef = div} 
                style={{display: this.props.showConnectionLostMsg ? 'none' : '',
                        borderColor: this.props.chatConfig.searchBoxBorderColor
                }}>
                   <ChatInputField
                       language={this.props.language}
                       chatConfig={this.props.chatConfig}
                       chatAgentMode={this.props.chatAgentMode}
                       uploadFilesList={this.props.uploadFilesList}
                       sendMessage={(disableAutomComplete) => this.handleSendMessage(disableAutomComplete)}
                       stopMessage={this.props.stopMessage}
                       showStopMessage={  this.props.showStopMessage}
                       sendUserIsWriting={this.props.sendUserIsWriting}
                       handleMessageChanges={(value, disableAutomComplete) => this.handleMessageChanges(value, disableAutomComplete)}
                       message={this.state.message}
                       onInputUpKeyStroke={this.handleInputUpKeyStroke}
                       onInputDownKeyStroke={this.handleInputDownKeyStroke}
                       chatInputText ={this.props.chatInputText}
                       chatInputMax ={this.props.chatInputMax}
                       handleResetChatInput = {this.handleResetChatInput}
                       clearSpeechBubble={this.props.clearSpeechBubble}
                       reEnableMostAskedQuestions={this.props.reEnableMostAskedQuestions}
                       fileUploadedText={this.props.fileUploadedText}
                       setShowSearchBotChatField={(show) => this.props.setShowSearchBotChatField(show)}
                       speechBubbleList= {this.props.speechBubbleList}

                   />
                    {!this.state.message ?
                        <Fragment>
                            {this.props.chatConfig && this.props.integrationType !== IntegrationTypeEnum.facebook && (this.props.chatConfig.enableUpload || this.props.chatAgentMode) ?
                                <ChatAttachment 
                                sendMessage={this.props.sendMessage} 
                                chatConfig={this.props.chatConfig}  
                                language={this.props.language} 
                                uploadFileComplete={this.props.uploadFileComplete} 
                                setSnackbarErrorMessage={this.props.setSnackbarErrorMessage} 
                                handleAddUploadedFiles={(name) => this.props.handleAddUploadedFiles(name)} 
                                handleResetUploadedFiles={() => this.props.handleResetUploadedFiles()} 
                                fileUploadedListRemove={this.props.fileUploadedListRemove} 
                                handleFlushDeleteUploadedFile={this.props.handleFlushDeleteUploadedFile} 
                                handleAddPendingFiles={(item) => this.props.handleAddPendingFiles(item)}
                                flushPendingFiles={this.props.flushPendingFiles}
                                pendingFiles={this.props.pendingFiles}
                                fileUploadedText={this.props.fileUploadedText}
                                
                                /> : null}

                            {
                            this.props.chatConfig && this.props.language && this.props.chatConfig.showMenuInInput && this.props.chatConfig.chatMenuItemList.filter(cmi => cmi.languageId === this.props.language.id).length > 0 ?
                                <ChatInputMenu
                                    chatConfig={this.props.chatConfig}
                                    language={this.props.language}
                                    sendIntent={this.props.sendIntent}
                                    showAbove= {this.props.chatConfig.layoutMode === LayoutTypeEnum.chatbot ||
                                        (this.props.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.props.chatConfig.openDownwards === false)}
                                    anchorEl={this.inputRef}
                                /> : null}
                        </Fragment> : null }
                </div>




            </div>
        );
    }
}

export default ChatInput;
